import React, { useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import useGetDiagnosticSlots from '../hooks/useGetDiagnosticSlots'
import Text from '../../../components/atoms/Text'
import Loader from '../../../components/atoms/Loader'
import Button from '../../../components/atoms/GoodFlipButton'
import ShimmerLoader from './Shimmer'
import ArrowIcon from '../../../components/atoms/Arrow'
import { useNavigate } from 'react-router-dom'

const DiagnosticSlotsDetails = () => {
  const {
    dates,
    loading,
    slotsResponse,
    fetchSlots,
    defaultFormValues,
    createOrder,
    creatingOrder,
    confirmOrderState,
    gettingPlanDetails,
    // diagnosticOffering,
    // isDiagnosticFree,
  } = useGetDiagnosticSlots()

  const navigate = useNavigate()

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { isDirty, isValid },
  } = useForm({
    defaultValues: {
      ...defaultFormValues,
    },
    mode: 'onBlur',
    reValidateMode: 'onSubmit',
  })

  const watchSelectedDate = watch('appointment_date')

  useEffect(() => {
    if (watchSelectedDate && fetchSlots) {
      fetchSlots(watchSelectedDate)
      setValue('collection_slot_id', '')
      setValue('slot_time', '')
    }
  }, [watchSelectedDate, fetchSlots])

  const navigateToCart = (cartData) => {
    navigate('/cart', { state: { cartData } })
  }

  if (creatingOrder || gettingPlanDetails || confirmOrderState.loading)
    return <Loader />

  return (
    <div className="p-6 max-w-md mx-auto h-[calc(100vh-150px)] max-h-[calc(100vh-150px)] overflow-y-auto">
      <Text
        tag="p"
        variant="display"
        size="small"
        className={'text-text-primary'}
      >
        Select Slot for Sample Collection
      </Text>

      {/* <form onSubmit={handleSubmit(createOrder)}> */}
      <form onSubmit={handleSubmit(navigateToCart)}>
        <div className="mb-6 space-y-4 pt-4">
          <Text
            tag="p"
            variant="label"
            size="small"
            className="text-text-quartenary"
          >
            Select Date
          </Text>
          <Controller
            name="appointment_date"
            control={control}
            render={({ field }) => (
              <div className="flex space-x-4 overflow-x-auto">
                {dates?.map((date) => (
                  <button
                    key={date.fullDate}
                    type="button"
                    onClick={() => field.onChange(date.fullDate)}
                    className={`transition-colors ease-in delay-200 flex flex-col items-center justify-center min-w-14 max-w-14 h-20 p-3 rounded-full border 
                      ${
                        field.value === date.fullDate
                          ? 'bg-blue-600'
                          : 'bg-white'
                      }`}
                  >
                    <Text
                      tag="p"
                      variant="label"
                      size="large"
                      className={
                        field.value === date.fullDate
                          ? 'text-text-primary-on-brand'
                          : 'text-text-quartenary'
                      }
                    >
                      {date.day}
                    </Text>
                    <Text
                      tag="p"
                      variant="label"
                      size="large"
                      bold="true"
                      className={
                        field.value === date.fullDate
                          ? 'text-text-primary-on-brand'
                          : 'text-text-quartenary'
                      }
                    >
                      {date.date}
                    </Text>
                  </button>
                ))}
              </div>
            )}
          />
        </div>

        {loading ? (
          <ShimmerLoader />
        ) : slotsResponse && slotsResponse?.length > 0 ? (
          <div className="space-y-6">
            {slotsResponse?.map((item) => (
              <div key={item.title} className="space-y-3">
                <div className="flex items-center gap-3">
                  <img
                    src={item.icon_url}
                    alt={item.title}
                    className="h-7 w-7"
                  />
                  <Text
                    tag="p"
                    variant="label"
                    size="small"
                    className="text-text-quartenary"
                  >
                    {item.title}
                  </Text>
                </div>
                <Controller
                  name="slot_time"
                  control={control}
                  render={({ field }) => (
                    <div className="grid grid-cols-2 gap-4">
                      {item.slots?.map((slot) => (
                        <button
                          key={slot.slot_id}
                          type="button"
                          onClick={() => {
                            field.onChange(slot.time)
                            setValue(
                              'collection_slot_id',
                              slot.slot_id.toString(),
                            )
                          }}
                          className={`py-2 px-4 rounded-full border 
                        ${
                          field.value === slot.time
                            ? 'bg-blue-600 text-white'
                            : 'bg-white text-gray-700'
                        }`}
                        >
                          {slot.time}
                        </button>
                      ))}
                    </div>
                  )}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center">No Slots Available</div>
        )}

        <div className="fixed max-w-lg lg:max-w-5xl xl:max-w-6xl mx-auto bottom-0 left-0 right-0 bg-WHITE py-4">
          <Button
            isSubmitButton
            title="Proceed"
            disabled={
              !isDirty || !isValid || loading || confirmOrderState.loading
            }
            loading={confirmOrderState.loading}
            type="goodflip_primary"
            leftIcon={null}
            rightIcon={<ArrowIcon direction="right" color="#FFFFFF" />}
          />
        </div>
      </form>
    </div>
  )
}

export default DiagnosticSlotsDetails
